export default {
  getLayout: ({ layout }) => layout,
  getStatic: ({ isStatic }) => isStatic,
};
